import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getTokenData } from 'store/modules/utils/getBearerToken';
import { store } from 'store/main-reducer';
import { TYPES } from 'store/modules/options/actions';

let tokenRenewalTimeoutId: number | undefined;

export const RenewToken = () => {
  const tokenData = useSelector(getTokenData);

  // Every time a new token is fetched, setup a timeout to fetch another one
  useEffect(() => {
    const expiresIn = tokenData?.expiresIn;

    if (expiresIn) {
      // Use the expiresIn but 10s less
      const expiresInMS = (parseInt(expiresIn, 10) - 10) * 1000;

      clearTimeout(tokenRenewalTimeoutId);
      // Setup renewal of token
      tokenRenewalTimeoutId = setTimeout(() => {
        console.log('Fetching refresh token');
        store.dispatch({
          type: TYPES.GET_TOKEN,
        });
      }, expiresInMS) as unknown as number;
    }
  }, [tokenData]);

  return null;
};
